/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { buildUrl } from "../../utils/bindUrl";
import { IItem, IResponseListItems, IResponseShowItem } from "../../interfaces/items";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";

const BASE = "/items";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listItems({
  filter,
  includes,
  page,
  limit,
  select,
  sort,
}: IListParams) {
  const { data } = await api.get<IResponseListItems>(BASE, {
    params: { filter, includes, page, limit, select, sort },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showItem({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowItem>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createItem({ item }: { item: IItem }) {
  const { data } = await api.post<IResponseShowItem>(BASE, { item });
  return data;
}

export async function updateItem({
  id,
  item,
}: {
  id: string | number;
  item: IItem;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowItem>(url, { item });
  return data;
}

export async function deleteItems({ ids }: { ids: number[] }) {
  await api.delete<any>(BASE, {
    params: { ids },
    paramsSerializer: (params) => serialize(params),
  });
}
